import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import { V1Props } from "./TextTextV1.interface";
import Text from "./components/Text/Text.component";
import { useAlignment } from "./hooks/useAlignment.hook";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./TextTextV1.module.scss";

const V1 = (props: V1Props) => {
    const { backgroundColorClass, hasBackgroundColor, alternativeButtonTheme } = useBackgroundColor(
        props.backgroundColor
    );
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);

    const { alignmentClass } = useAlignment(props.alignment, S);

    return (
        <div className={cn(S.wrapper, paddingClass, backgroundColorClass, alignmentClass)}>
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Header */}
                    <div className={S.header}>
                        {/** Tagline */}
                        {props.tagline ? <span className={S.tagline}>{props.tagline}</span> : null}

                        {/** Title */}
                        {props.headline ? (
                            <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                                {props.headline}
                            </DA_Title>
                        ) : null}

                        {/** Text */}
                        {props.text ? <DA_Text html={props.text} noPadding /> : null}
                    </div>

                    {/** Items */}
                    <div className={S.items}>
                        {props.items?.map((item, index) => (
                            <Text
                                key={index}
                                text={item.text}
                                buttons={item.buttons}
                                buttonTheme={alternativeButtonTheme}
                                headline={item.headline}
                            />
                        ))}
                    </div>
                </div>
            </DA_Container>
        </div>
    );
};

export default V1;
